import template from './orders-print.html';
import controller from './print.controller';
import './print.scss';

let printComponent = {
    template,
    controller
};

export default printComponent;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/orders/print/print.component.js